import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { ListAffiliateCodesResponse } from './list-affiliate-codes.types'

const listAffiliateCodes = async (): Promise<ListAffiliateCodesResponse> => {
  const response = await apiClient.get<ListAffiliateCodesResponse>(
    '/v1/affiliation/codes',
  )
  return response.data
}

export const useListAffiliateCodes = () => {
  return useQuery({
    queryKey: ['affiliate-codes'],
    queryFn: () => listAffiliateCodes(),
  })
}
